/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import Loading from './asset/loading.svg';

export const StyledLoading = styled(Loading)`
  width: 50px;
  height: ${(props) => css`${props.size}`};
`;
